module.exports = __webpack_public_path__ + "img/update.a2bc324e.svg";